import wretchAdapter from '@/shared/api/adapters/wretch';

export default wretchAdapter(CONFIG.INTEGRATIONS_GO_ROOT);
